<template>
  <div class="contacts-page row">
    <div class="left-wrap" :class="wrapClas">
      <contacts-header
        :search-query="searchQuery"
        :on-search-submit="onSearchSubmit"
        this-selected-contact-id=""
        :on-input-search="onInputSearch"
        :on-toggle-create="onToggleCreate"
        :on-toggle-import="onToggleImport"
        @filter-tags="filterContacts"
        :header-title="label"
      />
      <contacts-table
        :contacts="records"
        :show-search-empty-state="showEmptySearchResult"
        :is-loading="uiFlags.isFetching"
        :on-click-contact="openContactInfoPanel"
        :active-contact-id="selectedContactId"
        :sort-config="sortConfig"
        @on-sort-change="onSortChange"
      />
      <div class="page-meta">
        Showing <strong>{{ contactsFetched }}</strong> of
        <strong>{{ meta.count }}</strong> items
      </div>
      <!--      <div>-->
      <!--        <p>Showing {{ contactsFetched }} of {{ meta.count }} records</p>-->
      <!--      </div>-->
      <div class="load-more-container">
        <span
          class="load-more-text"
          :class="{ 'clickable': canLoadMore }"
          @click="handleLoadMore"
        >
          {{ loadMoreText }}
        </span>
      </div>
<!--      <table-footer-->
<!--        :on-page-change="onPageChange"-->
<!--        :current-page="Number(meta.currentPage)"-->
<!--        :total-count="meta.count"-->
<!--      />-->
    </div>
    <contact-info-panel
      v-if="showContactViewPane"
      :contact="selectedContact"
      :on-close="closeContactInfoPanel"
    />
    <create-contact :show="showCreateModal" @cancel="onToggleCreate" />
    <woot-modal :show.sync="showImportModal" :on-close="onToggleImport">
      <import-contacts v-if="showImportModal" :on-close="onToggleImport" />
    </woot-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import ContactsHeader from './Header';
import ContactsTable from './ContactsTable';
import ContactInfoPanel from './ContactInfoPanel';
import CreateContact from 'dashboard/routes/dashboard/conversation/contact/CreateContact';
import TableFooter from 'dashboard/components/widgets/TableFooter';
import ImportContacts from './ImportContacts.vue';

const DEFAULT_PAGE = 1;

export default {
  components: {
    ContactsHeader,
    ContactsTable,
    TableFooter,
    ContactInfoPanel,
    CreateContact,
    ImportContacts,
  },
  props: {
    label: { type: String, default: '' },
  },
  data() {
    return {
      tags: '',
      filter: false,
      fetchedRecordsCount: 0,
      recordsPerPage: 15,
      allRecordsFetched: false,
      searchQuery: '',
      showCreateModal: false,
      showImportModal: false,
      selectedContactId: '',
      sortConfig: { name: 'asc' },
    };
  },
  computed: {
    ...mapGetters({
      accountId: 'getCurrentAccountId',
      records: 'contacts/getContacts',
      uiFlags: 'contacts/getUIFlags',
      meta: 'contacts/getMeta',
    }),
    contactsFetched() {
      return Math.min(this.fetchedRecordsCount, this.meta.count);
    },
    showEmptySearchResult() {
      const hasEmptyResults = !!this.searchQuery && this.records.length === 0;
      return hasEmptyResults;
    },
    canLoadMore() {
      if (this.fetchedRecordsCount == this.meta.count) {
        return false;
      } else if (this.fetchedRecordsCount < this.meta.count) {
        return true;
      } else if (this.fetchedRecordsCount > this.meta.count) {
        this.contactsFetched = this.meta.count
        return false;
      }
    },
    loadMoreText() {
      return this.canLoadMore ? 'Load more contacts' : 'No more contacts';
    },
    selectedContact() {
      if (this.selectedContactId) {
        const contact = this.records.find(
          item => this.selectedContactId === item.id
        );
        return contact;
      }
      return undefined;
    },
    showContactViewPane() {
      return this.selectedContactId !== '';
    },
    wrapClas() {
      return this.showContactViewPane ? 'medium-9' : 'medium-12';
    },
    pageParameter() {
      const selectedPageNumber = Number(this.$route.query?.page);
      return !Number.isNaN(selectedPageNumber) &&
        selectedPageNumber >= DEFAULT_PAGE
        ? selectedPageNumber
        : DEFAULT_PAGE;
    },
  },
  watch: {
    label() {
      this.tags = '';
      this.fetchContacts(DEFAULT_PAGE);
    },
    tags(newTags) {

      this.searchQuery = '';
      if (newTags.length > 0) {
        this.fetchContacts(DEFAULT_PAGE);
      }
    },
  },
  mounted() {
    this.searchQuery = this.$route.params.q;
    this.fetchContacts(this.pageParameter);
  },
  methods: {
    handleLoadMore() {
      if (this.canLoadMore) {
        this.loadMoreContacts();
      }
    },
    updatePageParam(page) {
      window.history.pushState({}, null, `${this.$route.path}?page=${page}`);
    },
    getSortAttribute() {
      let sortAttr = Object.keys(this.sortConfig).reduce((acc, sortKey) => {
        const sortOrder = this.sortConfig[sortKey];
        if (sortOrder) {
          const sortOrderSign = sortOrder === 'asc' ? '' : '-';
          return `${sortOrderSign}${sortKey}`;
        }
        return acc;
      }, '');
      if (!sortAttr) {
        this.sortConfig = { name: 'asc' };
        sortAttr = 'name';
      }
      return sortAttr;
    },
    fetchContacts(page) {
      if (page == 1) {
        this.fetchedRecordsCount = this.recordsPerPage;
      } else {
        this.fetchedRecordsCount += this.recordsPerPage;
      }
      this.updatePageParam(page);
      const requestParams = {
        page,
        sortAttr: this.getSortAttribute(),
        label: this.label,
        filter_tags: this.tags,
      };
      if (!this.searchQuery) {
        this.$store.dispatch('contacts/get', requestParams);
      } else {
        this.$store.dispatch('contacts/search', {
          search: this.searchQuery,
          ...requestParams,
        });
      }
    },
    loadMoreContacts() {
      if (this.canLoadMore) {
        this.fetchContacts(this.meta.currentPage + 1);
      }
    },
    onInputSearch(event) {
      const newQuery = event.target.value;
      const refetchAllContacts = !!this.searchQuery && newQuery === '';
      this.searchQuery = newQuery;
      if (refetchAllContacts) {
        this.$router.push(`/app/accounts/${this.accountId}/contacts/`);
      }
    },
    onSearchSubmit() {
      this.$router.push(`${this.searchQuery}`).catch(error => {
        console.info(error.message);
      });
      this.$router.go();
    },
    onPageChange(page) {
      this.selectedContactId = '';
      this.fetchContacts(page);
    },
    openContactInfoPanel(contactId) {
      this.selectedContactId = contactId;
      this.showContactInfoPanelPane = true;
    },
    closeContactInfoPanel() {
      this.selectedContactId = '';
      this.showContactInfoPanelPane = false;
    },
    onToggleCreate() {
      this.showCreateModal = !this.showCreateModal;
    },
    onToggleImport() {
      this.showImportModal = !this.showImportModal;
    },
    onSortChange(params) {
      this.sortConfig = params;
      this.fetchContacts(this.meta.currentPage);
    },
    filterContacts(tags) {
      this.tags = tags.map(tag => tag.title);
      this.filter = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.contacts-page {
  width: 100%;
}

.left-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.load-more-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.load-more-text {
  color: #6e6e6e;
  cursor: default;
  font-size: 1.7rem;

  &.clickable {
    color: #1f93ff;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
}

</style>
